module.exports = {"pt-BR":{"staticPages":{"components":{"errorPage":{"button":"Voltar à página inicial"}}}}}